import { NewsScreen } from '../features/news'

export function NewsPage() {
  return <NewsScreen />
}
